import { useParams } from "react-router-dom";
import Title from "../components/Title";
import PhotoEdit from '../components/gallery/PhotoEdit';
import useLocalization from '../hooks/use-localization';
import '../resources/css/gallery-edit.css';
import { useGetGalleryQuery } from '../store';

export default function PhotoEditPage() {

    const { id } = useParams();
    const photoId = parseInt(id);

    const { data } = useGetGalleryQuery();
    const localization = useLocalization();
    const formLocalization = localization.newsManagement || {};

    const photo = (data || []).find(x => x.id === photoId);

    const targetPhoto = photo || {
        id: 0,
        src: '',
        title: ''
    };

    return (
        <>
            <Title value={localization.photoGallery}></Title>
            <div className="gallery-wrapper">
                <PhotoEdit photo={targetPhoto} labels={formLocalization}></PhotoEdit>
            </div>
        </>
    );
}